// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3NbSRVKESe0lkJ5Y8TJXK3","filter":"tUfyXnykfnFIHVEq-MyB3","input-wrapper":"_2kciyBwzAotIg0ZS5bts1A","datepickers-section":"ABm0sf2MacyuPCREKXoZe","data-picker":"_1ffeFk0phbcs3N8eW4KoRx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Journal/components/FilterMyJournals.mod.css
// module id = 1797
// module chunks = 0